<template>
    <!-- 添加或修改用户配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="1000px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="140px">
            <el-row>
                <el-col :span="24" style="margin-bottom: 20px;" v-if="title == '转寄详情'">
                    <el-table v-loading="loading" :data="tableData" ref="multipleTable">
                        <el-table-column label="平台" align="left" key="platform" prop="platform" />
                        <el-table-column label="店铺名称" align="left" key="shopname" prop="shopname" />
                        <el-table-column label="品名" align="left" key="productname" prop="productname" />
                        <el-table-column label="规格" align="left" key="specification" prop="specification" />
                        <el-table-column label="单价" align="left" key="unitprice" prop="unitprice" />
                        <el-table-column label="购买数量" align="left" key="paynum" prop="paynum" />
                        <el-table-column label="支付金额" align="left" key="payprice" prop="payprice" />
                        <el-table-column label="购买快递单号" align="left" key="couriernumber" prop="couriernumber" />
                        <el-table-column label="原箱编码" align="left" key="orderencoding" prop="orderencoding" />
                    </el-table>
                    <!-- <div v-show="this.tableData.length > 0">
                        <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
                            @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                        </pagination>
                    </div> -->
                </el-col>
                <el-col :span="24">
                    <el-form-item label="转寄快递单号" prop="forwardtrackingnumber">
                        <el-input v-model="form.forwardtrackingnumber" clearable placeholder="转寄快递单号" style="width: 410px;"
                            size="small" :disabled="(title == '转寄详情' && logintype == 'HCM') || form.rewardsstatus == 1" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="转寄日期" prop="forwarddate">
                        <el-date-picker v-model="form.forwarddate" value-format="yyyy-MM-dd" type="date"
                            placeholder="请选择确认日期" style="width: 410px;" size="small" :disabled="(title == '转寄详情' && logintype == 'HCM') || form.rewardsstatus == 1"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="转寄运费支付截图" required>
                        <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                            :show-file-list="false" :before-upload="handleBeforeUpload"
                            :on-success="handleUploadSuccess" accept="image/png, image/jpg" :multiple="true"
                            :ref="elUpload">
                            <el-button size="small" type="primary" v-if="logintype !== 'HCM' && form.rewardsstatus != 1">点击上传</el-button>
                        </el-upload>
                        <div v-for="(image, index) in forwardpaymentscreenshot" :key="index"
                            style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                            <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                            <i class="el-icon-error" style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                @click="delIcon(index)"  v-if="logintype !== 'HCM' && form.rewardsstatus != 1"></i>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="转寄运费金额" prop="forwardpaymentprice">
                        <el-input v-model="form.forwardpaymentprice" type="number" clearable placeholder="转寄运费金额"
                            style="width: 410px;" size="small" :disabled="(title == '转寄详情' && logintype == 'HCM') || form.rewardsstatus == 1" />
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '转寄详情'">
                    <el-form-item label="创建时间">
                        {{ form.createtime | fullTime }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '转寄详情'">
                    <el-form-item label="创建人">
                        {{ form.createuser }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '转寄详情'">
                    <el-form-item label="更新时间" v-if="form.updatetime">
                        {{ form.updatetime | fullTime }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '转寄详情'">
                    <el-form-item label="更新人" v-if="form.updateuser">
                        {{ form.updateuser }}
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm" v-if="logintype !== 'HCM' && form.rewardsstatus != 1">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
// import pagination from "../../../components/dataTable/pagination";
export default {
    name: "hcmChildforward",
    components: {
        // pagination
    },
    data() {
        return {
            loading: false,
            tableData: [],
            currentPage: 0,
            totalNum: 0,
            logintype: '',
            elUpload: true,
            // 表单参数
            form: {
                forwarddate: null,
                forwardpaymentprice: null,
                forwardtrackingnumber: null,
            },
            rules: {
                forwardtrackingnumber: [
                { required: true, message: '请填写转寄快递单号', trigger: 'blur' },
                ],
                forwarddate: [
                    { required: true, message: '请选择转寄日期', trigger: 'blur' },
                ],
                forwardpaymentprice: [
                    { required: true, message: '请填写转寄运费金额', trigger: 'blur' },
                ]
            },
            forwardpaymentscreenshot: [],
            open: false,
            title: '',
        };
    },
    created() {
        this.logintype = JSON.parse(localStorage.getItem('userData')).logintype;
    },
    methods: {
        // 新增
        handleAdd(data, title) {
            console.log(data,'hhhhh')
            this.title = title;
            this.form.forwardtrackingnumber = null;
            this.form.forwarddate = null;
            this.form.forwardpaymentprice = null;
            this.forwardpaymentscreenshot = [];
            if (this.title == '转寄详情') {
                this.form = data.details;
                this.forwardpaymentscreenshot = this.form.forwardpaymentscreenshot.split(',');
                this.form.forwarddate = this.$options.filters.fullTime(this.form.forwarddate);
                this.tableData = data.forwardidlistListbmc;
                this.getList();
            } else {
                console.log(data)
                this.form.ordergoodsbmc = data.data;
                this.form.dealerid = data.dealerid[0];
            }
            this.open = true;
        },
        getList() {

        },
        // 删除截图
        delIcon(index) {
            this.forwardpaymentscreenshot.splice(index, 1)
        },
        // 图片上传前判断
        handleBeforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('上传文件大小不能超过 20MB!');
            }
            return isLt20M;
        },
        // 图片上传成功
        handleUploadSuccess(res) {
            this.forwardpaymentscreenshot.push(res.data.data);
            this.form.forwardpaymentscreenshot = ''
            this.form.forwardpaymentscreenshot = this.forwardpaymentscreenshot.join(',');
            this.elUpload = false;
        },
        // handleSizeChange(val) {
        //     this.queryParams.pageSize = `${val}`
        //     this.getList();
        // },
        // handleCurrentChange(val) {
        //     this.queryParams.pageNo = `${val}`
        //     this.getList();
        // },
        // 提交
        submitForm() {
            console.log(this.form)
            this.$refs["form"].validate((valid) => {
                if (this.forwardpaymentscreenshot.length == 0) {
                    this.$message.warning('请上传转寄运费支付截图！');
                    return;
                }
                if (valid) {
                    fetch({
                        url: "hcm/hcmOrderForwardbmc/savaOrderForwardbmc",
                        method: "post",
                        data: JSON.stringify(this.form),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        noFormat: false,
                        responseType: "json"
                    }).then((res) => {
                        if (res.status === '10000') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            this.open = false;
                            this.$emit('call-parent-method');
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(err => {
                        this.$message.error('服务器出错');
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.open = false;
        },
    }
};
</script>
<style lang="scss"></style>